const MARK_SRC = 'assets/assistant-mark.svg';

/**
 * Ramp-filled assistant head used across FAB, header, welcome, and bubbles.
 * @param {Object} [options]
 * @param {number} [options.size=24]
 * @param {string} [options.className='ai-mark']
 * @returns {HTMLElement}
 */
export function createAssistantMark({ size = 24, className = 'ai-mark' } = {}) {
  const wrap = document.createElement('span');
  wrap.className = className;
  wrap.setAttribute('aria-hidden', 'true');

  const img = document.createElement('img');
  img.src = MARK_SRC;
  img.alt = '';
  img.width = size;
  img.height = size;
  wrap.appendChild(img);

  return wrap;
}
